import { resolveEffectiveTenantSlug } from "./backofficeContext";
import { resolveTenantFromHost } from "./tenant";
import { getTenantLogoUrl } from "./tenantBranding";

const BASE_DOMAIN =
  import.meta.env.VITE_BASE_DOMAIN ?? "tercerespacio.com.ar";

/**
 * Applies tenant theming and preloads navbar logo before React mounts.
 */
export const bootstrapDocumentTenant = (): void => {
  const hostname = window.location.hostname;
  const effectiveSlug = resolveEffectiveTenantSlug(hostname);

  document.documentElement.dataset.tenant = effectiveSlug;

  const resolution = resolveTenantFromHost(hostname, BASE_DOMAIN);

  if (!resolution?.slug) {
    return;
  }

  const logoHref = getTenantLogoUrl(resolution.slug, "navbar");
  const existing = document.querySelector<HTMLLinkElement>(
    'link[data-tenant-logo-preload="true"]',
  );

  if (existing) {
    existing.href = logoHref;
    return;
  }

  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = logoHref;
  link.dataset.tenantLogoPreload = "true";
  document.head.appendChild(link);
};
